"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhitePaperInterestRateModelFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "baseRatePerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "multiplierPerYear",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "baseRatePerBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplierPerBlock",
                type: "uint256",
            },
        ],
        name: "NewInterestParams",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "baseRatePerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "blocksPerYear",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "getBorrowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserveFactorMantissa",
                type: "uint256",
            },
        ],
        name: "getSupplyRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isInterestRateModel",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "multiplierPerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "utilizationRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class WhitePaperInterestRateModelFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(baseRatePerYear, multiplierPerYear, overrides) {
        return super.deploy(baseRatePerYear, multiplierPerYear, overrides || {});
    }
    getDeployTransaction(baseRatePerYear, multiplierPerYear, overrides) {
        return super.getDeployTransaction(baseRatePerYear, multiplierPerYear, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.WhitePaperInterestRateModelFactory = WhitePaperInterestRateModelFactory;
WhitePaperInterestRateModelFactory.bytecode = _bytecode;
WhitePaperInterestRateModelFactory.abi = _abi;
//# sourceMappingURL=WhitePaperInterestRateModelFactory.js.map